<template>
    <div style="margin-top: 30px;">
          <div style="margin: 20px;"> 
              欢迎来到 清河素养协同共育 后台管理系统!
              </div>

 

 
    </div>
</template>

<script>
    import applicationUserManager from "../Auth/applicationusermanager";
    // import {getServerInfo,getAccessLogs} from '../api/api';
  
  export default {
        name: "Welcome",
         data() {
            return {
                listLoading: false,
                logs: [],
                serverInfo:{}
            }
        },
        mounted() {
            var curTime = new Date()
            if(window.localStorage.TokenExpire){
                var expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
                if(curTime>=expiretime){
                    if (global.IS_IDS4) {
                        applicationUserManager.login();
                    } else {
                        this.$router.push('/login');
                    }
                }
            }else {
                if (global.IS_IDS4) {
                    applicationUserManager.login();
                } else {
                    this.$router.push('/login');
                }
            }

            // getServerInfo({}).then((res) => {
            //     this.serverInfo = res.data.response;
            // });

            //    getAccessLogs({}).then((res) => {
            //         this.logs = res.data.response;
            //         this.listLoading = false;
            //         //NProgress.done();
            //     });

        },
    }
</script>

<style scoped>
.note .text {
    font-size: 14px;
  }

 .note .item {
    margin-bottom: 18px;
  }
</style>
